import { useCallback, useEffect, useRef, useState } from "react";
import unsplash from "../api/unsplash";
export const consulenzaAuth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
});
export default function useConsulenzaData(endpoint, clienteId, mese) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const generation = useRef(0);
  const key = `${endpoint}:${clienteId}:${mese || ""}`;
  const current = useRef(key);
  current.current = key;
  const invalidate = useCallback(() => {
    generation.current += 1;
  }, []);
  const reload = useCallback(async () => {
    if (current.current !== key) return;
    const n = ++generation.current;
    setLoading(true);
    setError("");
    try {
      const r = await unsplash.get(endpoint, {
        ...consulenzaAuth(),
        params: { cliente: clienteId, ...(mese ? { mese } : {}) },
      });
      if (n === generation.current && current.current === key)
        setData(r.data.data);
    } catch (e) {
      if (n === generation.current && current.current === key)
        setError(e.response?.data?.message || "Impossibile caricare i dati");
    } finally {
      if (n === generation.current && current.current === key)
        setLoading(false);
    }
  }, [endpoint, clienteId, mese, key]);
  useEffect(() => {
    setData(null);
    reload();
    return invalidate;
  }, [reload, invalidate]);
  return { data, error, loading, reload };
}
